import React from 'react';
import './hours-drop.css';

export default function HoursDrop() {
  return (
    <div className='hours-container'>
        <h6>Service</h6>
        <table>
            <thead>
                <tr>
                    <th>Days</th>
                    <th>Time</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Monday</td>
                    <td>9AM - 7PM</td>
                </tr>
                <tr>
                    <td>Tuesday</td>
                    <td>9AM - 7PM</td>
                </tr>
                <tr>
                    <td>Wednesday</td>
                    <td>9AM - 7PM</td>
                </tr>
                <tr>
                    <td>Thursday</td>
                    <td>9AM - 7PM</td>
                </tr>
                <tr>
                    <td>Friday</td>
                    <td>9AM - 7PM</td>
                </tr>
                <tr>
                    <td>Saturday</td>
                    <td>10AM - 5PM</td>
                </tr>
                <tr>
                    <td>Sunday</td>
                    <td>Closed</td>
                </tr>
            </tbody>
        </table>
    </div>
  );
}
